// TODO: Unifify with Engine.

export enum ErrorType {
  Author,
  Warning,
  Error,
}
